import io from "socket.io-client";

const socket = io(process.env.REACT_APP_SOCKET_URL || "");
// const socket = io("https://connector.getjobsdone.nl");
export const listen = (event: string, callback: (data: any) => void) =>
	socket.off(event).on(event, callback);

export const off = (event: string) => socket?.off(event);

export default socket;
